var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("ul", { staticClass: "tabChoice d-flex" }, [
      _vm.saleAreas[_vm.DELIVERY]
        ? _c(
            "li",
            {
              staticClass:
                "flex-grow-1 text-center fsize-14 text-bold cursor-pointer m-5 mb-0 pb-10",
              class: {
                selected: _vm.currentTab == _vm.DELIVERY,
                "color-black": _vm.currentTab != _vm.DELIVERY,
              },
              on: {
                click: function ($event) {
                  return _vm.setCurrentTab(_vm.DELIVERY)
                },
              },
            },
            [_vm._v("\n\t\t\tLivraison\n\t\t")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.saleAreas[_vm.SALE_AREAS.TO_STAY] ||
      _vm.saleAreas[_vm.SALE_AREAS.TO_GO]
        ? _c(
            "li",
            {
              staticClass:
                "flex-grow-1 text-center size-14 text-bold cursor-pointer m-5 mb-0 pb-10",
              class: {
                selected: _vm.currentTab == _vm.CLICK_COLLECT,
                "color-black": _vm.currentTab != _vm.CLICK_COLLECT,
              },
              on: {
                click: function ($event) {
                  return _vm.setCurrentTab(_vm.CLICK_COLLECT)
                },
              },
            },
            [_vm._v("\n\t\t\tClick & Collect\n\t\t")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.currentTab == _vm.CLICK_COLLECT
      ? _c("ul", { staticClass: "list-group d-flex" }, [
          _vm.saleAreas[_vm.SALE_AREAS.TO_STAY]
            ? _c(
                "li",
                {
                  staticClass:
                    "flex-grow-1 cursor-pointer list-group-item flex-start-center",
                  class: {
                    selected:
                      _vm.CLICK_COLLECT_SaleAreaId == _vm.SALE_AREAS.TO_STAY,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setCCSaleAreaId(_vm.SALE_AREAS.TO_STAY)
                    },
                  },
                },
                [_c("div", [_vm._v("Sur place")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.saleAreas[_vm.SALE_AREAS.TO_GO]
            ? _c(
                "li",
                {
                  staticClass:
                    "flex-grow-1 cursor-pointer list-group-item flex-start-center",
                  class: {
                    selected:
                      _vm.CLICK_COLLECT_SaleAreaId == _vm.SALE_AREAS.TO_GO,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setCCSaleAreaId(_vm.SALE_AREAS.TO_GO)
                    },
                  },
                },
                [_c("div", [_vm._v("A emporter")])]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }